export default __webpack_public_path__ + "static/media/Boots of the Steel Behemoth.66576c3e.jpg";